import { wallet } from 'utils/wallet';

import {
  actionAccountOwner,
  actions as activeAccountActions
} from 'redux/slices/account';
import { AppDispatch } from 'redux/store';
const { setAccountId, setAuthReady, actionAccountBalance } =
  activeAccountActions;

export const refreshAccount = () => async (dispatch: AppDispatch) => {
  try {
    await wallet.initialize();

    if (wallet.accountId) {
      dispatch(setAccountId({ accountId: wallet.accountId }));
      await dispatch(actionAccountOwner());
      dispatch(actionAccountBalance());
    }
  } finally {
    // Allow PrivateRoute to decide only after wallet-selector has hydrated.
    dispatch(setAuthReady(true));
  }
};
